'use client';
import { Flexbox, Typography } from '@doc/ui-components';
import { useTranslations } from '@power-core/toolkit';
import type { FooterProps } from '../types/footer.type';

export const Footer = ({ copyright }: FooterProps) => {
	const t = useTranslations();

	return (
		<Flexbox justify='between' alignContent='center' className='min-h-0 min-w-0 border-t-n100_grey pt-4 pb-5 px-9 shrink-0'>
			<Typography className='text-n500_light_text'>{copyright}</Typography>
			<Typography className='text-n500_light_text'>{`${t('T_VERSION')} 1.0.104`}</Typography>
		</Flexbox>
	);
};
